import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'platform-ui': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > & {
        id: string;
        component: string;
        [key: string]: any;
      };
    }
  }
}

export const ThirdPartyPreferences = observer(() => {
  useEffect(() => {
    document.getElementById('platform-wc-styles')?.removeAttribute('disabled');
    return () => {
      document
        .getElementById('platform-wc-styles')
        ?.setAttribute('disabled', 'true');
    };
  }, []);

  return (
    <platform-ui
      id="platform-ui-lender-admin-config"
      component="lender_admin_config"
    />
  );
});
